export default __webpack_public_path__ + "static/media/coinbase-wallet.6fee0bf9.png";